export const Region = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 8C18 4.69 15.31 2 12 2C8.69 2 6 4.69 6 8C6 11.49 9.62 16.19 11.23 18.12C11.63 18.6 12.36 18.6 12.76 18.12C14.38 16.19 18 11.49 18 8ZM10 8C10 6.9 10.9 6 12 6C13.1 6 14 6.9 14 8C14 9.1 13.11 10 12 10C10.9 10 10 9.1 10 8ZM6 22C5.45 22 5 21.55 5 21C5 20.45 5.45 20 6 20H18C18.55 20 19 20.45 19 21C19 21.55 18.55 22 18 22H6Z"
    />
  </svg>
);
